export default __webpack_public_path__ + "static/media/apply-now.1173b93c.gif";